import type { ParsedBusiness } from "~/data/.server/business";

export function InsuranceSection(props: {
  business: ParsedBusiness;
}) {
  const { insurance } = props.business;

  // Extract data from insurance.detail
  const {
    bipdInsuranceRequired,
    bipdInsuranceOnFile,
    cargoInsuranceRequired,
    cargoInsuranceOnFile,
    bondInsuranceOnFile,
    bondInsuranceRequired,
  } = insurance?.detail || {};

  return (
    <>
      {/* Insurance Requirements vs. On File */}
      <div className="mb-6 max-w-full overflow-x-scroll">
        <h4 className="mb-2 font-semibold">
          Insurance Requirements vs. On File
        </h4>
        <table className="min-w-full overflow-x-scroll border">
          <thead>
            <tr>
              <th className="border px-4 py-2">Insurance Type</th>
              <th className="border px-4 py-2">Required</th>
              <th className="border px-4 py-2">On File</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2">BIPD Insurance</td>
              <td className="border px-4 py-2">
                {bipdInsuranceRequired || "N/A"}
              </td>
              <td className="border px-4 py-2">
                {bipdInsuranceOnFile || "N/A"}
              </td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Cargo Insurance</td>
              <td className="border px-4 py-2">
                {cargoInsuranceRequired || "N/A"}
              </td>
              <td className="border px-4 py-2">
                {cargoInsuranceOnFile || "N/A"}
              </td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Bond Insurance</td>
              <td className="border px-4 py-2">
                {bondInsuranceRequired || "N/A"}
              </td>
              <td className="border px-4 py-2">
                {bondInsuranceOnFile || "N/A"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Active Insurance Policies */}
      <div className="mb-6 max-w-full overflow-x-scroll">
        <h4 className="mb-2 font-semibold">Active Insurance Policies</h4>
        {(insurance?.active?.length ?? 0) > 0 ? (
          <table className="min-w-full border">
            <thead>
              <tr>
                <th className="border px-4 py-2">Carrier</th>
                <th className="border px-4 py-2">Policy Number</th>
                <th className="border px-4 py-2">Effective Date</th>
                <th className="border px-4 py-2">Cancellation Date</th>
                <th className="border px-4 py-2">Coverage From</th>
                <th className="border px-4 py-2">Coverage To</th>
                <th className="border px-4 py-2">Form Type</th>
              </tr>
            </thead>
            <tbody>
              {insurance.active?.map((policy, index) => (
                <tr key={index}>
                  <td className="border px-4 py-2">
                    {policy?.carrier || "N/A"}
                  </td>
                  <td className="border px-4 py-2">
                    {policy?.policyNumber || "N/A"}
                  </td>
                  <td className="border px-4 py-2">
                    {policy?.effectiveDate || "N/A"}
                  </td>
                  <td className="border px-4 py-2">
                    {policy?.cancellationDate || "N/A"}
                  </td>
                  <td className="border px-4 py-2">
                    {policy?.coverageFrom || "N/A"}
                  </td>
                  <td className="border px-4 py-2">
                    {policy?.coverageTo || "N/A"}
                  </td>
                  <td className="border px-4 py-2">
                    {policy?.formType || "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No active insurance policies available.</p>
        )}
      </div>
    </>
  );
}
